<div id="mmc-securities-model">
  <div class="block">
    <span class="red">*</span>
    The information you provide is required and will be visible to advisors. However, they will not see the targets
    until they subscribe to the model.
    <br/>
    To enter a cash allocation in the model, use the symbol $CASH.
  </div>

  <div class="import-or-add-secutities-block">
    <button class="btn-medium-secondary import-model-targets" (click)="importModelTarget()" [disabled]="data.isProcessing">Import Model Targets
    </button>
    <span style="padding: 0 15px;">-or-</span>
    <input type="text" placeholder="Enter or paste symbols, separated by spaces." pInputText style="width:350px;" [disabled]="data.isProcessing"
      [(ngModel)]="typedSecurities">
    <button class="btn-medium-secondary" (click)="addSecuritiesFromMaster()"
      [disabled]="typedSecurities.trim() === ''">Add
    </button>
  </div>

  @if (!isUiTest) {
    <div style="width: 95%;position:relative;" class="block">
      <span style="font-weight: bold;">{{ recordsMsg }} securities</span>
      <irb-inventory-grid id="mmc-securities-model-grid"
        [style.height]="height"
        [showSideBar]='false'
        [gridOptions]="gridOptions"
        [componentName]="'MmcSecuritiesModelComponent'"
        [frameworkComponents]='frameworkComponents'
        (cellValueChanged)="onCellValueChanged()"
        (gridReady)="onGridReady($event)">
      </irb-inventory-grid>
      <div class="mmc-securities-model-total">
        @if (totalTarget !== '') {
          <div style="float: left;">Total Security Allocations</div>
        }
        <div style="float:right; padding-right: 5px;"
        [style]="{color: isValid ? 'initial' : '#C11312'}">{{ totalTarget }}</div>
      </div>
      <div style="clear: both;"></div>
    </div>
  }
  <irb-common-dialog #dialog></irb-common-dialog>
</div>
